/**
 * Persistance de utm_source (ex. ?utm_source=qrcode) pour relay vers /form.
 */

export const UTM_SOURCE_STORAGE_KEY = "op-biscuit-ferrero-utm-source";

function isNonEmpty(value) {
  return value != null && String(value).trim() !== "";
}

export function readUtmSource() {
  try {
    const val = sessionStorage.getItem(UTM_SOURCE_STORAGE_KEY);
    if (!isNonEmpty(val)) return null;
    return String(val);
  } catch {
    return null;
  }
}

export function writeUtmSource(value) {
  sessionStorage.setItem(UTM_SOURCE_STORAGE_KEY, String(value));
}

/** utm_source présent dans les paramètres GET. */
export function readUtmSourceFromQuery(query = {}) {
  const val = query.utm_source;
  if (!isNonEmpty(val)) return null;
  return String(val);
}

/** Fusionne utm_source GET en sessionStorage (conservé pendant le parcours quiz → /form). */
export function syncUtmSourceFromQuery(query = {}) {
  const fromQuery = readUtmSourceFromQuery(query);
  if (!fromQuery) return;

  if (readUtmSource() !== fromQuery) {
    writeUtmSource(fromQuery);
  }
}

/** Objet `relay` pour `<Form :relay="…" />` si utm_source est connu. */
export function buildUtmRelay() {
  const val = readUtmSource();
  if (!val) return {};
  return { utm_source: val };
}

export function clearUtmSource() {
  try {
    sessionStorage.removeItem(UTM_SOURCE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
